import { createContext } from 'react';

import { StandardInputsState } from './_types';

export const StandardInputsContext = createContext<StandardInputsState>(
  undefined as never
);
